
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/termination-of-parental-rights",
      function () {
        return require("private-next-pages/practice-areas/termination-of-parental-rights/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/termination-of-parental-rights"])
      });
    }
  